"use client"

import { defineSlotRecipe } from "@chakra-ui/react"
import { editableAnatomy } from "@chakra-ui/react/anatomy"

const table = defineSlotRecipe({
  className: "hydrologiq-editable",
  slots: editableAnatomy.keys(),

  variants: {
    variant: {
      hydrologiq: {
        input: {
          padding: "5px !important",
          "--focus-ring-color": "#39aed2",
          _focusVisible: {
            outlineOffset: "-1px",
          },
        },
        editTrigger: {
          _hover: {
            opacity: 0.8,
          },
        },
        submitTrigger: {
          _hover: {
            opacity: 0.8,
          },
        },
        cancelTrigger: {
          _hover: {
            opacity: 0.8,
          },
        },
      },
    },
  },
})

export default table
